import {Component, OnInit} from '@angular/core';
import {CrudService} from "@core/shared/services/crud.service";
import {CrudAction} from "@core/shared/models/crud";

@Component({
    selector: 'app-page-offer-create',
    templateUrl: './page-offer-attribute-create.component.html',
    styleUrls: ['./page-offer-attribute-create.component.scss'],
    providers: [
        CrudService
    ],
    standalone: false
})
export class PageOfferAttributeCreateComponent implements OnInit {

    constructor(
        private _crudService: CrudService
    ) {}

    ngOnInit() {

        this._crudService.setAction(CrudAction.Create);
    }
}
